import React, { useState } from "react";
import { Button, Modal, Radio } from "antd";
import TextArea from "antd/es/input/TextArea";
import "./style.css";
import { ErrorDeactivate } from "../../../assets/icons";
import ConfirmAccDeletionDeactivation from "./ConfirmAccDeletionDeactivation";
import { Form, Formik } from "formik";

const DeleteDeactivateAcc = ({
   open,
   onCancel,
   setOpen,
   title,
   description,
   buttonText,
   action
}) => {
   const [openConfirmDeactivation, setOpenConfirmDeactivation] = useState(false);
   const [formInitialValues, setFormInitialValues] = useState({ reason: "", description: "" });
   const [selectedReason, setSelectedReason] = useState("");

   // Function to open the confirmation modal
   const showModal = () => {
      setOpenConfirmDeactivation(true);
      setOpen(false);
   };

   const onClose = () => {
      setOpenConfirmDeactivation(false);
      setFormInitialValues({ reason: "", description: "" });
   };

   const confirmProps = {
      openConfirmDeactivation,
      onCancel: onClose,
      title: action === "delete" ? "Confirm account deletion" : "Confirm account deactivation",
      description:
         action === "delete"
            ? "You're about to permanently delete your account and data."
            : "You're about to deactivate your account.",
      otherDesc: "Are you sure you want to continue?",
      button: action === "delete" ? "Delete account" : "Deactivate account"
   };

   const handleFormSubmit = (values) => {
      setFormInitialValues(values);
      showModal(action);
   };

   return (
      <>
         <Modal
            open={open}
            onCancel={onCancel}
            className="modalContainer"
            destroyOnClose
            footer={[]}
         >
            <Formik
               initialValues={formInitialValues}
               onSubmit={handleFormSubmit}
               enableReinitialize
            >
               {({ handleChange, values, setFieldValue }) => (
                  <Form>
                     <div className="d-flex flex-column" style={{ gap: "24px" }}>
                        <div className="d-flex align-items-center flex-column firstSection">
                           <div className="d-flex justify-content-center align-items-center innerSection">
                              <img src={ErrorDeactivate} alt="error icon" />
                              <span className="title-span">{title}</span>
                           </div>
                           <span className="span-description">{description}</span>
                        </div>
                        <div>
                           <span className="span-style">
                              We'd appreciate your feedback if you're willing to share with us why
                              you're considering this.
                           </span>
                           <div className="d-flex flex-column" style={{ gap: "16px" }}>
                              <Radio.Group
                                 name="description"
                                 onChange={(e) => {
                                    const value = e.target.value;
                                    setFieldValue("description", value);
                                    setSelectedReason(value);
                                 }}
                                 value={selectedReason}
                                 className="d-flex flex-column"
                                 style={{ gap: "14px" }}
                              >
                                 <Radio
                                    className="radio-container"
                                    value="I no longer use this service."
                                 >
                                    I no longer use this service.
                                 </Radio>
                                 <Radio
                                    className="radio-container"
                                    value="I'm concerned about my privacy."
                                 >
                                    I'm concerned about my privacy.
                                 </Radio>
                                 <Radio
                                    className="radio-container"
                                    value="I'm not satisfied with the service."
                                 >
                                    I'm not satisfied with the service.
                                 </Radio>
                                 <Radio className="radio-container" value="Other">
                                    Other (please specify)
                                 </Radio>
                              </Radio.Group>
                              <TextArea
                                 name="description"
                                 onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setFieldValue("description", inputValue);
                                    if (
                                       [
                                          "I no longer use this service.",
                                          "I'm concerned about my privacy.",
                                          "I'm not satisfied with the service.",
                                          "Other"
                                       ].includes(inputValue)
                                    ) {
                                       setSelectedReason(inputValue);
                                    }
                                 }}
                                 value={values?.description}
                                 placeholder="Enter your answer here"
                              />
                           </div>
                        </div>
                        <div>
                           <span className="span-style">
                              Is there anything we could have done to improve your experience?
                              Please tell us more about why you're deactivating your account.
                           </span>
                           <TextArea
                              type="text"
                              name="reason"
                              onChange={handleChange}
                              value={values?.reason}
                              placeholder="Enter your answer here"
                           ></TextArea>
                        </div>
                        <div className="footer-buttons">
                           <Button className="cancel-deactivation" onClick={onCancel}>
                              Cancel
                           </Button>
                           <Button className="deactivate-button" htmlType="submit">
                              {buttonText}
                           </Button>
                        </div>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
         <ConfirmAccDeletionDeactivation
            {...confirmProps}
            action={action}
            formData={formInitialValues}
         />
      </>
   );
};

export default DeleteDeactivateAcc;
